import { render } from "./EscritorioCompanyias.vue?vue&type=template&id=7286a5fd"
import script from "./EscritorioCompanyias.vue?vue&type=script&lang=js"
export * from "./EscritorioCompanyias.vue?vue&type=script&lang=js"

import "./EscritorioCompanyias.vue?vue&type=style&index=0&id=7286a5fd&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__